var _g, _path, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvidentPrimaryLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1479.6 2033.9",
    style: {
      enableBackground: "new 0 0 1479.6 2033.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M975.6,0H182.3h-2H0v474.5l0,24.1v1535.3h1479.6V504C1479.6,225.6,1275.3,0,975.6,0z M1391.3,1939.5H90.7V90.1h892.2 c225.6,0,408.4,182.9,408.4,408.4V1939.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.6,1484.8v92.3h240.5v84.5H282.6v96.2h260v91H181.8v-455h360.7v91H282.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M946.2,1507.6l-117,341.2H688.8l-117-341.2h97.5l89.7,261.3l89.7-261.3H946.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1068.2,1757.9h-93.1v90.9h124v-60C1099.2,1771.7,1085.3,1757.9,1068.2,1757.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidentPrimaryLogoBlack);
export default __webpack_public_path__ + "static/media/Evident-Primary Logo-Black.2012fb9d468f1d8cffaaf1f25b806bbe.svg";
export { ForwardRef as ReactComponent };